import type { HostedFields } from 'braintree-web'

export async function tokeniseCard(hostedFieldsInstance: HostedFields, cardholderName: string) {
  try {
    const payload = await hostedFieldsInstance.tokenize({ cardholderName })

    return { payload, error: null }
  } catch (error) {
    return { payload: null, error }
  }
}
